/* eslint-disable max-lines-per-function */
import { FieldBase } from '@/components/form';
import { Toggle } from '@e2n/ui';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useTranslation } from 'react-i18next';

export function BerechnungsartMonatToggle() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();

  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-neutrals-900 text-xl font-bold leading-7">
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.berechnungsartMonat.description',
        )}
      </h2>
      <form.AppField
        name="bezahlung.sollstunden.berechnungsartMonat"
        listeners={{
          onChange({ value }) {
            if (value === 'exakt') {
              form.resetField('bezahlung.sollstunden.monatsstunden');
              form.resetField(
                'bezahlung.sollstunden.unbezahlteUeberstundenMonat',
              );
            } else if (value === 'durchschnitt') {
              form.resetField('bezahlung.sollstunden.arbeitstage');
              form.resetField('bezahlung.sollstunden.tagessoll');
            }
          },
        }}>
        {(field) => (
          <FieldBase>
            <div className="flex items-start gap-4">
              <Toggle
                pressed={field.state.value === 'durchschnitt'}
                onPressedChange={() => field.handleChange('durchschnitt')}
                variant={'outline'}
                className="flex items-center justify-start gap-2 p-4 h-auto">
                {t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.berechnungsartMonat.options.durchschnitt',
                )}
              </Toggle>
              <Toggle
                pressed={field.state.value === 'exakt'}
                onPressedChange={() => field.handleChange('exakt')}
                variant={'outline'}
                className="flex items-center justify-start gap-2 p-4 h-auto">
                {t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.berechnungsartMonat.options.exakt',
                )}
              </Toggle>
            </div>
          </FieldBase>
        )}
      </form.AppField>
    </div>
  );
}
